import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import AOS from 'aos';
import "./Homepages/Secondpage.css";
import "./Homepages/Homepage1.css";
import Landing from "./pages/Landing";
import Statistics from "./pages/Statistics";
import Services from "./pages/Services";
import Tenders from "./pages/Tenders";
import RTI from "./pages/RTI";
import Gallery from "./pages/Gallery";
import ContactUs from "./pages/ContactUs";
import WarehouseDashboard from "./pages/WarehouseDashboard";
import AdminPage from "./pages/AdminPage";
import Reports from './pages/Reports';
import OtherLinks from './pages/OtherLinks';
import "./App.css";
import NotFound from './pages/NotFound';
import MainLayout from './Config/Mainlayout';
import ManagementOrgChart from './component/ManagementOrgChart';
import WarehouseOrgChart from './component/WarehouseOrgChart';
import ScreenReader from './pages/ScreenReader';
import Disclaimer from './component/FooterLinks/Disclaimer';
import Copyrights from './component/FooterLinks/Copyrights';
import Privacy from './component/FooterLinks/Privacy';
import TermsAndConditions from './component/FooterLinks/TermsAndConditions';
import Accessibility from './component/FooterLinks/Accessibility';
import Hyperlink from './component/FooterLinks/Hyperlink';
import Orgcharts from './component/About/Orgcharts';
import WarehouseOffices from './component/About/WarehouseOffices';
import HeadOffice from './component/About/HeadOffice';
import RegionalOffices from './component/About/RegionalOffices';
import BoardDirectors from './component/About/BoardDirectors';
import UnAuthModal from './component/UnAuthModal';
import { registerUnauthorizedHandler } from './api/authsession';
import { BASE_API } from './Config/Config';

// import React, { useEffect, useState } from "react";
// import {
//     BrowserRouter,
//     Routes,
//     Route,
//     Outlet,
//     Navigate,
//     useNavigate
// } from "react-router-dom";


// Import your existing pages and components here

function ProtectedRoute() {
    const userDetails = JSON.parse(
        sessionStorage.getItem("userdetails") || "null"
    );

    const isAuthenticated = !!userDetails?.id;

    return isAuthenticated
        ? <Outlet />
        : <Navigate to="/" replace />;
}

function AppContent() {
    const [unauthorizedOpen, setUnauthorizedOpen] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);

    const openLoginModal = () => {
        setLoginModalOpen(true);
    };

    const closeLoginModal = () => {
        setLoginModalOpen(false);
    };

    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: "ease-out-cubic",
        });
    }, []);

    useEffect(() => {
        registerUnauthorizedHandler(() => {
            setUnauthorizedOpen(true);
        });

        return () => {
            registerUnauthorizedHandler(null);
        };
    }, []);

    useEffect(() => {
        const handleTabClose = () => {
            sessionStorage.removeItem("userdetails");
            navigator.sendBeacon(
                `${BASE_API}/apis/logout.php`,
                new Blob([], { type: "application/json" })
            );
        };

        window.addEventListener("pagehide", handleTabClose);

        return () => {
            window.removeEventListener("pagehide", handleTabClose);
        };
    }, []);

    const handleUnauthorizedLogin = () => {
        setUnauthorizedOpen(false);
        navigate("/", { replace: true });
    };

    return (
        <div className="d-flex flex-column min-vh-100">

            {/* Global Unauthorized Modal */}
            <UnAuthModal
                open={unauthorizedOpen}
                onLogin={handleUnauthorizedLogin}
                openLoginModal={openLoginModal}
            />

            <main className="flex-grow-1">
                <Routes>

                    <Route element={
                        <MainLayout
                            loginModalOpen={loginModalOpen}
                            openLoginModal={openLoginModal}
                            closeLoginModal={closeLoginModal}
                        />
                    }>

                        {/* Public Routes */}
                        <Route path="/" element={<Landing />} />
                        <Route path="/screen-reader" element={<ScreenReader />} />
                        <Route path="/statistics" element={<Statistics />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/tenders" element={<Tenders />} />
                        <Route path="/rti" element={<RTI />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/other-links" element={<OtherLinks />} />
                        <Route path="/contact-us" element={<ContactUs />} />

                        {/* About Links */}
                        <Route path="/about/board-directors" element={<BoardDirectors />} />
                        <Route path="/about/organizational-structure" element={<Orgcharts />} />
                        <Route path="/about/head-office" element={<HeadOffice />} />
                        <Route path="/about/regional-offices" element={<RegionalOffices />} />
                        <Route path="/about/warehouse-offices" element={<WarehouseOffices />} />

                        {/* Footer Links */}
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route path="/Copyrights" element={<Copyrights />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/hyperlink" element={<Hyperlink />} />
                        <Route path="/accessibility" element={<Accessibility />} />
                        <Route path="/termsandconditions" element={<TermsAndConditions />} />

                        {/* Private Routes */}
                        <Route element={<ProtectedRoute />}>
                            <Route path="/warehouse-dashboard" element={<WarehouseDashboard />} />
                            <Route path="/warehouse-Admin" element={<AdminPage />} />
                            <Route path="/warehouse-Admin/report" element={<Reports />} />
                            <Route path="/warehouse-Admin/management-org-chart" element={<ManagementOrgChart />} />
                            <Route path="/warehouse-Admin/warehouse-org-chart" element={<WarehouseOrgChart />} />
                        </Route>

                    </Route>

                    {/* Not Found */}
                    <Route path="*" element={<NotFound />} />

                </Routes>
            </main>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent />
        </BrowserRouter>
    );
}

export default App;
